export enum TimeSchemaType {
  None = 0,
  ExactDay = 1,
  NextWorkday = 2,
  LastWorkday = 3
}
